<template>
  <span>
    <button
      class="btn"
      :class="printer === null ? 'btn-outline-danger' : 'btn-outline-success'"
      @click="connectPrinter"
      v-blur-on-click
    >
      🖨 {{ printer === null ? 'offline' : 'online' }}
    </button>
  </span>
</template>

<script>
export default {
  computed: {
    printer() {
      return this.$store.state.printer
    }
  },
  methods: {
    connectPrinter() {
      if (this.printer === null) {
        const ip = prompt('Printer IP?', '192.168.178.141')
        if (ip) {
          this.$store.dispatch('connectPrinter', ip)
        }
      } else {
        const confirmed = confirm('Disconnect printer?')
        if (confirmed) {
          this.$store.dispatch('disconnectPrinter')
        }
      }
    },
    printReceipt(receipt) {
      const printer = this.printer
      printer.addFeedLine(10)
      printer.addTextFont(this.printer.FONT_B)
      printer.addTextLineSpace(50)
      printer.addTextSize(3, 3)
      printer.addTextStyle(true, false, true, printer.COLOR_1)
      printer.addTextAlign(printer.ALIGN_CENTER)
      receipt.titleLines.forEach(titleLine => {
        printer.addText(titleLine)
      })
      printer.addFeedLine(1)

      printer.addTextSize(2, 2)
      if (receipt.receiptCount) {
        printer.addText(` Bon ${receipt.receiptCount.current} / ${receipt.receiptCount.total} `)
      }
      printer.addFeedLine(3)

      printer.addTextStyle(false, false, false, printer.COLOR_1)

      receipt.itemLines.forEach(itemLine => {
        printer.addTextAlign(printer.ALIGN_LEFT)
        printer.addText(itemLine.label + '\n')
        printer.addTextAlign(printer.ALIGN_RIGHT)
        printer.addText(itemLine.sum)
        printer.addFeedLine(2)
      })

      receipt.sumLines.forEach(sumLine => {
        printer.addTextAlign(printer.ALIGN_RIGHT)
        printer.addText(sumLine)
      })

      printer.addFeedLine(2)

      printer.addCut(printer.CUT_FEED)
      printer.send()
    },
    printItemUnavailableHandout(params) {
      const { resident, product } = params
      const printer = this.printer
      let greeting
      if (resident) {
        greeting = resident.lastName
          ? resident.gender === 'female'
            ? `Liebe Frau ${resident.lastName}`
            : `Lieber Herr ${resident.lastName}`
          : resident.gender === 'female'
          ? 'Liebe Bewohnerin'
          : 'Lieber Bewohner'
      }
      if (!resident) {
        greeting = `Lieber Hausbedarf`
      }
      printer.addFeedLine(3)
      printer.addTextSize(2, 2)
      printer.addTextAlign(printer.ALIGN_LEFT)
      printer.addText(`${greeting},\n\nwir konnten den Artikel\n\n\n`)
      printer.addTextAlign(printer.ALIGN_CENTER)
      printer.addText(`${product.brandName}\n${product.label}\n\n\n`)
      printer.addTextAlign(printer.ALIGN_LEFT)
      printer.addText(
        'leider nicht liefern, da\ndieser aktuell nicht zu bekommen war. Wir\nhaben ihn daher aus\nIhrer Bestellung\ngenommen.\n\nViele Grüße,\nIhr Emma Team'
      )
      printer.addFeedLine(7)
      printer.addCut(printer.CUT_FEED)
      printer.send()
    },
    printItemPartiallyAvailableHandout(params) {
      const { resident, product } = params
      const printer = this.printer
      let greeting
      if (resident) {
        greeting = resident.lastName
          ? resident.gender === 'female'
            ? `Liebe Frau ${resident.lastName}`
            : `Lieber Herr ${resident.lastName}`
          : resident.gender === 'female'
          ? 'Liebe Bewohnerin'
          : 'Lieber Bewohner'
      }
      if (!resident) {
        greeting = `Lieber Hausbedarf`
      }
      printer.addFeedLine(3)
      printer.addTextSize(2, 2)
      printer.addTextAlign(printer.ALIGN_LEFT)
      printer.addText(`${greeting},\n\nwir konnten den Artikel\n\n\n`)
      printer.addTextAlign(printer.ALIGN_CENTER)
      printer.addText(`${product.brandName}\n${product.label}\n\n\n`)
      printer.addTextAlign(printer.ALIGN_LEFT)
      printer.addText(
        'leider nicht vollständig\nliefern, da dieser\naktuell nicht zu \nbekommen war.\nWir haben daher die\nnicht lieferbare Menge\naus Ihrer Bestellung\ngenommen.\n\nViele Grüße,\nIhr Emma Team'
      )
      printer.addFeedLine(7)
      printer.addCut(printer.CUT_FEED)
      printer.send()
    }
  }
}
</script>
